import { createBrowserHistory } from "history";

/* Export - History */
export const History = createBrowserHistory();
